// Authorization Code + PKCE is completed on the backend. The callback never
// holds a verifier or exchanges a token with Okta.
// Return only the fields the backend accepts, even on an IdP error response.
export function takeEmployeeCallback() {
  const query = new URLSearchParams(window.location.search);
  window.history.replaceState(null, "", window.location.pathname);
  const state = query.get("state");
  const code = query.get("code");
  const error = query.get("error");
  const valid = (value, limit) =>
    typeof value === "string" &&
    value.trim().length > 0 &&
    value.length <= limit &&
    !/[\x00-\x1f\x7f-\x9f]/.test(value);
  if (
    query.has("interaction_code") ||
    query.getAll("state").length !== 1 ||
    query.getAll("code").length > 1 ||
    query.getAll("error").length > 1 ||
    !valid(state, 512) ||
    (code === null) === (error === null) ||
    (code !== null && !valid(code, 4096)) ||
    (error !== null && !valid(error, 128))
  )
    return null;
  return code !== null ? { state, code } : { state, error };
}
